'use client';

import {
  ArticleCard,
  AuthorByline,
  CardDate,
  Excerpt,
  Image,
  Title,
} from '@/app_components/ArticleSections/ArticleCards/ArticleCard';
import { useContentCardTrackingData } from '@/app_lib/services/contentCardTracking';
import { getExtendedArticle } from '@/app_lib/services/contentCardTracking/utils';
import type { ArticlePreviewFeatured } from '@/app_lib/types/ArticlePreview';
import type { ModuleType } from '@/app_lib/types/ContentCardTracking';

export const ArticleCardFeatured = ({
  article,
  className,
  index = 1,
  moduleType = 'section_featured',
  priority,
}: {
  article: ArticlePreviewFeatured;
  className?: string;
  index?: number;
  moduleType?: ModuleType;
  priority?: boolean;
}) => {
  const generateContentCardTrackingData = useContentCardTrackingData();

  return (
    <ArticleCard
      className={className}
      variant='featured'
    >
      <Image
        contentCardTrackingData={generateContentCardTrackingData({
          article: getExtendedArticle(article),
          cardPosition: index,
          clickTarget: 'image',
          moduleType,
        })}
        image={article.image}
        imageAlt={article.imageAlt || article.title}
        priority={priority}
        url={article.url}
        variant='featured'
      />
      <div className='flex flex-col gap-sm'>
        <Title
          contentCardTrackingData={generateContentCardTrackingData({
            article: getExtendedArticle(article),
            cardPosition: index,
            clickTarget: 'headline',
            moduleType,
          })}
          title={article.title}
          url={article.url}
          variant='featured'
        />
        <Excerpt
          excerpt={article.excerpt}
          variant='featured'
        />
      </div>
      <div className='flex flex-col'>
        <AuthorByline
          authors={article.authors}
          contentCardTrackingData={generateContentCardTrackingData({
            article: getExtendedArticle(article),
            cardPosition: index,
            clickTarget: 'author',
            moduleType,
          })}
          variant='featured'
        />
        <CardDate
          dateGmt={article.dateGmt}
          variant='featured'
        />
      </div>
    </ArticleCard>
  );
};
